/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FrontendUnit {
    INTEGER = 'INTEGER',
    PERCENT = 'PERCENT',
    DECIMAL1 = 'DECIMAL1',
}
